module.exports = __webpack_public_path__ + "static/media/ranger4wd2006.e4368c39.webp";